import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderLogo',
  setup(__props) {

// Импортируем картинку только при монтировании компонента,
// чтобы избежать увеличения бандла, если компонент не используется
  const iconSrc = ref('');
  onMounted(() => {
    import('./arch.png').then((module) => {
      // Получаем URL картинки из модуля
      iconSrc.value = module.default;
    });
  });

return { __sfc: true,iconSrc }
}

})